/** @jsxImportSource @emotion/react */
import { useState, useEffect, useCallback } from "react";
import { accessAPI, Titulo, Boton } from "../../shared";
import TarjetaDestacado from "./TarjetaDestacado";
import NuevoDestacado from "./NuevoDestacado";
import { EVENTO_DESTACADOS_ACTUALIZADOS } from "../asistente/ContextoAsistente";

// Destacados personales del admin, arriba del tablero del home. La sección se
// muestra aunque esté vacía: desde su título se crean destacados a mano.
export default function MisDestacados({ toast }) {
  const [destacados, setDestacados] = useState([]);
  const [sidebarNuevo, setSidebarNuevo] = useState(false);

  const cargar = useCallback(() => {
    accessAPI(
      "GET",
      "admin/misdestacados",
      null,
      (respuesta) => setDestacados(respuesta),
      (error) =>
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.[0]?.msg || "No se pudieron cargar tus destacados.",
          sticky: true
        })
    );
  }, [toast]);

  useEffect(() => {
    cargar();
    // El asistente puede crear o quitar destacados mientras el home está
    // abierto: avisa con este evento y se recarga la lista.
    window.addEventListener(EVENTO_DESTACADOS_ACTUALIZADOS, cargar);
    return () =>
      window.removeEventListener(EVENTO_DESTACADOS_ACTUALIZADOS, cargar);
  }, [cargar]);

  function descartar(id) {
    const anteriores = destacados;
    setDestacados((prev) => prev.filter((d) => d.id !== id));
    accessAPI(
      "DELETE",
      `admin/misdestacados/${id}`,
      null,
      () => {},
      (error) => {
        setDestacados(anteriores);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.[0]?.msg || "No se pudo descartar el destacado.",
          sticky: true
        });
      }
    );
  }

  // Mismo orden que la API: primero los prioritarios, después por fecha.
  function ordenar(lista) {
    return [...lista].sort(
      (a, b) =>
        Number(b.prioritario) - Number(a.prioritario) ||
        new Date(b.fechaCreacion) - new Date(a.fechaCreacion)
    );
  }

  function alternarPrioritario(id) {
    const anteriores = destacados;
    const prioritario = !destacados.find((d) => d.id === id)?.prioritario;
    setDestacados((prev) =>
      ordenar(prev.map((d) => (d.id === id ? { ...d, prioritario } : d)))
    );
    accessAPI(
      "PATCH",
      `admin/misdestacados/${id}/prioritario`,
      { prioritario },
      () => {},
      (error) => {
        setDestacados(anteriores);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.[0]?.msg || "No se pudo actualizar el destacado.",
          sticky: true
        });
      }
    );
  }

  return (
    <div css={{ marginBottom: "1.5em" }}>
      <Titulo
        botones={
          <Boton transparente callback={() => setSidebarNuevo(true)}>
            Nuevo destacado
          </Boton>
        }
      >
        Mis destacados
      </Titulo>
      {destacados.length > 0 && (
        <div className="grid">
          {destacados.map((destacado) => (
            <TarjetaDestacado
              key={destacado.id}
              destacado={destacado}
              onDescartar={descartar}
              onAlternarPrioritario={alternarPrioritario}
            />
          ))}
        </div>
      )}

      <NuevoDestacado
        visible={sidebarNuevo}
        onHide={() => setSidebarNuevo(false)}
        onCreado={(esRecordatorio) => {
          setSidebarNuevo(false);
          // Un recordatorio no genera tarjeta hasta su fecha
          if (!esRecordatorio) cargar();
        }}
        toast={toast}
      />
    </div>
  );
}
